import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { cardsQueries } from '@/hooks/products/useCards'
import { sealedQueries } from '@/hooks/products/useSealedProducts'
import { useAuthStore } from '@/store/authStore'

export function usePrefetchBulkData() {
  const queryClient = useQueryClient()
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)

  useEffect(() => {
    if (!isAuthenticated) return

    // Pass staleTime so prefetch respects the defs' 24h freshness instead of
    // the 5-min global default — otherwise IDB-restored catalogs (almost always
    // >5 min old) get re-downloaded and re-parsed on every app open.
    queryClient.prefetchQuery({
      queryKey: cardsQueries.allList.queryKey(),
      queryFn: cardsQueries.allList.queryFn,
      staleTime: cardsQueries.allList.staleTime,
    })
    queryClient.prefetchQuery({
      queryKey: sealedQueries.allList.queryKey(),
      queryFn: sealedQueries.allList.queryFn,
      staleTime: sealedQueries.allList.staleTime,
    })
  }, [queryClient, isAuthenticated])
}
